export const REPEATER_STATUS = {
    Initiated: 1,
    Running: 2,
    Paused: 3,
    Completed: 4,
};
